import MySpinner from 'components/MySpinner'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import { IOffice } from './IOffice'
import OfficeInfo from './OfficeInfo'
import { reqGetOffices } from './OfficeRequests'
import { OfficesRecoilState } from './OfficesState'

interface IOfficeInfoWithLoadProps {
  officeId: number
}

const OfficeInfoWithLoad: React.FC<IOfficeInfoWithLoadProps> = ({ officeId }) => {
  const [offices, setOffices] = useRecoilState(OfficesRecoilState)
  const [office, setOffice] = useState<IOffice | null>(null)

  useEffect(() => {
    if (!offices || offices.length === 0) {
      reqGetOffices((items) => {
        if (items) setOffices(items)
      })
    }
  }, [offices, setOffices])

  useEffect(() => {
    if (offices) {
      const office = offices.find((office_) => office_.item_id === officeId)
      if (office) {
        setOffice(office)
      }
    }
  }, [officeId, offices])

  return <>{office ? <OfficeInfo office={office} /> : <MySpinner size='medium' />}</>
}
export default OfficeInfoWithLoad
